import MailSVG from "@design-system/ui-icons/vanilla/Mail"
import { createIcon } from "../createIcon"

export const MailIcon = createIcon(MailSVG)
